module.exports = __webpack_public_path__ + "img/Icon ionic-ios-arrow-down-black-small.f4fc7746.svg";